<!-- =========================================================================================
    File Name: TodoAddNew.vue
    Description: Add new todo component
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="px-6 pb-2 pt-6">
    <vs-button v-if="allowAdd" @click="activePrompt = true" class="w-full">{{ $t('Add') }}</vs-button>
    <vs-prompt
      :title="addText"
      :accept-text="$t('Add')"
      button-cancel="border"
      @cancel="clearFields"
      @accept="addTodo"
      @close="clearFields"
      :is-valid="validateForm"
      :active.sync="activePrompt"
    >
      <div id="prompt-add" >
        <form>
          <ValidationObserver ref="observer">
            <div v-if="displayStatus" class="vx-row">
              <div class="vx-col ml-auto flex">
                <vs-dropdown class="cursor-pointer flex" vs-custom-content>
                  <div class="status-icon" :class="`bg-${getStatusColor(taskLocal.status)}`">
                    <feather-icon :icon="getStatusIcon(taskLocal.status)" svgClasses="text-white stroke-current w-5 h-5" />
                  </div>
                  <!-- <vs-button radius color="success" type="flat" iconPack="feather" icon="icon-tag" @click.prevent></vs-button> -->

                  <vs-dropdown-menu style="z-index: 200001">
                    <vs-dropdown-item
                      @click.stop
                      v-for="(tag, index) in taskTags"
                      :key="index"
                    >
                      <vs-radio v-model="taskLocal.status" :vs-value="tag.value">{{ $t('KPU.KPUStatus.' +  tag.value) }}</vs-radio>
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>
              </div>
            </div>

            <div class="vx-row">
              <div class="vx-col w-full">
                <ValidationProvider :name="$t('KPU.ToDo.Name')" rules="required" v-slot="{ errors }">
                  <validated-input
                    :label="$t('KPU.ToDo.Name')"
                    v-model="taskLocal.name"
                  ></validated-input>
                  <validation-message>{{ errors[0] }}</validation-message>
                </ValidationProvider>
                <vs-textarea class="mt-5"
                  rows="5"
                  :label="$t('KPU.ToDo.Description')"
                  v-model="taskLocal.desc"
                />
              </div>
            </div>
            <div v-if="displayDueDate" class="vx-row">
              <div class="vx-col w-full">
                <form-label>{{$t('KPU.ToDo.DueDate')}}</form-label>
                <ValidationProvider :name="$t('KPU.ToDo.DueDate')" rules="required" v-slot="{ errors }">
                  <datepicker format="yyyy-MM-dd"
                              :placeholder="$t('KPU.ToDo.DueDate')"
                              v-model="taskLocal.dueDate"></datepicker>
                  <validation-message>{{ errors[0] }}</validation-message>
                </ValidationProvider>
              </div>
            </div>
          </ValidationObserver>
        </form>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import KPUStatusEnum from './../KPUStatusEnum.js'
import Datepicker from 'vuejs-datepicker'
import {
  ValidationMessage,
  ValidatedInput,
  FormLabel
} from "../../../shared/components";
export default {
  components: {
    ValidationMessage,
    Datepicker,
    ValidatedInput,
    FormLabel
  },
  props: {
    displayDueDate : {
      type: Boolean,
      default: false
    },
    displayStatus : {
      type: Boolean,
      default: true
    },
    addText : {
      type: String,
      default : "Add"
    },
    allowAdd : {
      type:Boolean,
      default : true
    }
  },
  data() {
    return {
      activePrompt: false,

      taskLocal: {
        id: 0,
        name: "",
        desc: "",
        isCompleted: false,
        dueDate: null,
        status: 0
      },
      tags: [
        {
          id: KPUStatusEnum.Ok,
          value : KPUStatusEnum.Ok,
          icon : 'ThumbsUpIcon',
          color: 'success'
        },
        {
          id: KPUStatusEnum.Warning,
          value : KPUStatusEnum.Warning,
          icon : 'AlertTriangleIcon',
          color: 'warning'
        },
        {
          id: KPUStatusEnum.BehindTarget,
          value : KPUStatusEnum.BehindTarget,
          icon : 'AlertOctagonIcon',
          color: 'danger'
        }
      ]
    };
  },
  computed: {
    taskTags() {
      return this.tags;
    },
    validateForm() {
      return this.taskLocal.name !== "" && (!this.$props.displayDueDate || this.taskLocal.dueDate !== null);
    }
  },
  methods: {
    getStatusIcon (status) {
      return this.tags.find(t => t.id === status).icon;
    },
    getStatusColor (status) {
      return this.tags.find(t => t.id === status).color;
    },
    clearFields() {
      Object.assign(this.taskLocal, {
        id: 0,
        name: "",
        desc: "",
        isCompleted: false,
        dueDate: null,
        status: 0
      });
    },
    addTodo() {
      this.$refs.observer.validate().then((result) => {
        if (result) {
          this.$emit("submit", this.taskLocal);
          this.clearFields();
        }
      });
    }
  }
};
</script>
<style lang="scss">
#prompt-add {
  .status-icon {
      border-radius: 50%;
      padding: .75rem;
      padding-bottom: 0.4rem;
  }
}
</style>
